import React from "react"

const ProgressBar = ({ selected }) => {
  return (
    <div className="mt-14 mx-auto w-2/5 flex justify-between medium:w-full">
      <div
        className={`w-32 py-5 rounded-3xl flex flex-col justify-center items-center  medium:py-3 medium:w-24 ${
          selected === 1 ? "shadow-lg text-pGreen " : "text-lgreen"
        }`}
      >
        <div
          className={`w-8 h-8 rounded-lg border-4 border-sbg-light-green flex justify-center items-center ${
            selected === 1 ? "border-sbg-prg-green" : "border-sbg-light-green"
          }`}
        >
          <h1 className="font-bold text-xl">1</h1>
        </div>
        <p className="text-center mt-3 medium:text-xs">Create event</p>
      </div>

      <div
        className={`w-32 py-5 rounded-3xl flex flex-col justify-center items-center  medium:py-3 medium:w-24 ${
          selected === 2 ? "shadow-lg text-pGreen " : "text-lgreen"
        }`}
      >
        <div
          className={`w-8 h-8 rounded-lg border-4 border-sbg-light-green flex justify-center items-center ${
            selected === 2 ? "border-sbg-prg-green" : "border-sbg-light-green"
          }`}
        >
          <h1 className="font-bold text-xl">2</h1>
        </div>
        <p className="text-center mt-3 medium:text-xs">Setup Registry</p>
      </div>

      <div
        className={`w-32 py-5 rounded-3xl flex flex-col justify-center items-center  medium:py-3 medium:w-24 ${
          selected === 3 ? "shadow-lg text-pGreen " : "text-lgreen"
        }`}
      >
        <div
          className={`w-8 h-8 rounded-lg border-4 border-sbg-light-green flex justify-center items-center ${
            selected === 3 ? "border-sbg-prg-green" : "border-sbg-light-green"
          }`}
        >
          <h1 className="font-bold text-xl">3</h1>
        </div>
        <p className="text-center mt-3 medium:text-xs">Publish</p>
      </div>
    </div>
  )
}

export default ProgressBar
